module.exports = __webpack_public_path__ + "pnskfsquadron/img/en-slider-4.jpg?114ea176";